import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstants } from '../constants/api-constants';
import { LinkedDocument } from '../models/linked-documents';

@Injectable({
  providedIn: 'root'
})
export class DocumentCommonService {

  constructor(private httpClient:HttpClient) { }

  // To Get Effective or fallback 
  //to latest version of documents based on document Numbers
  getEffectiveOrLatestVersionOfDocuments(documentNumbers: string[]): Observable<LinkedDocument[]> {
    return this.httpClient.post<LinkedDocument[]>(ApiConstants.Get_Documents_With_EffectiveOrLatestVersion_Api,documentNumbers);
  }
}
